import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-error-message-dialog',
    templateUrl: './error-message-dialog.component.html',
    styleUrls: ['./error-message-dialog.component.scss'],
    standalone: false
})
export class ErrorMessageDialogComponent {
  constructor(public dialogRef: MatDialogRef<ErrorMessageDialogComponent>) {}
}
